if ($("#mapdiv-usa").length > 0) {
    var map = (function () {
        /* http://docs.amcharts.com/3/javascriptmaps/AmMap */
        var map;
        var targetSVG = "M9,15.93 c-3.83,0-6.93-3.1-6.93-6.93S5.17,2.07,9,2.07s6.93,3.1,6.93,6.93S12.83,15.93,9,15.93";
        AmCharts.ready(function () {
            // * Set up our locations
            var mapLocations = [
                {
                    balloonText: 'Huntsville, AL',
                    url: '/state/al/huntsville',
                    latitude: 34.698021,
                    longitude: -86.678706
                },
                {
                    balloonText: 'Coastal, AL',
                    url: '/state/al/coastal-al',
                    latitude: 30.41140979831069,
                    longitude: -87.61713080963928
                },
                {
                    balloonText: 'Phoenix, AZ',
                    url: '/state/az/phoenix',
                    latitude: 34.1264,
                    longitude: -112.0478
                },
                {
                    balloonText: "Tucson, AZ",
                    url: '/state/az/tucson',
                    latitude: 32.2217,
                    longitude: -110.9265
                },
                {
                    balloonText: "Bay Area, CA",
                    url: '/state/ca/bay-area',
                    latitude: 37.7749,
                    longitude: -122.4194
                },
                {
                    balloonText: "Sacramento, CA",
                    url: '/state/ca/sacramento',
                    latitude: 38.7802,
                    longitude: -120.9402
                },
                {
                    balloonText: "Southern CA",
                    url: '/state/ca/southern-ca',
                    latitude: 34.0522,
                    longitude: -118.2437
                },
                {
                    balloonText: "Denver, CO",
                    url: '/state/co/denver',
                    latitude: 39.742043,
                    longitude: -104.991531
                },
                {
                    balloonText: "Fort Collins, CO",
                    url: '/state/co/fort-collins',
                    latitude: 40.448604,
                    longitude: -105.009421
                },
                {
                    balloonText: "Colorado Springs, CO",
                    url: '/state/co/colorado-springs',
                    latitude: 38.816914,
                    longitude: -104.715135
                },
                {
                    balloonText: "Orlando, FL",
                    url: '/state/fl/orlando',
                    latitude: 28.5383,
                    longitude: -81.3792
                },
                {
                    balloonText: "Ft. Myers, FL",
                    url: '/state/fl/south-florida',
                    latitude: 26.6406,
                    longitude: -81.8723
                },
                {
                    balloonText: "South Florida",
                    url: '/state/fl/south-florida',
                    latitude: 26.6168,
                    longitude: -80.0684
                },
                {
                    balloonText: "Tampa/Sarasota, FL",
                    url: '/state/fl/tampa',
                    latitude: 27.9506,
                    longitude: -82.4572
                },
                {
                    balloonText: "Jacksonville, FL",
                    url: '/state/fl/jacksonville',
                    latitude: 30.3322,
                    longitude: -81.6557
                },
                {
                    balloonText: "Palm Coast, FL",
                    url: '/state/fl/palm-coast',
                    latitude: 29.486959,
                    longitude: -81.158067
                },
                {
                    balloonText: "Atlanta, GA",
                    url: '/state/ga/atlanta',
                    latitude: 33.7489,
                    longitude: -84.3879
                },
                {
                    balloonText: "Coastal, MS",
                    url: '/state/ms/coastal-ms',
                    latitude: 30.38241016142048,
                    longitude: -89.0791896932507
                },
                {
                    balloonText: "Charlotte Metro, NC",
                    url: '/state/nc/charlotte',
                    latitude: 35.6866,
                    longitude: -80.8981
                },
                {
                    balloonText: "Raleigh, NC",
                    url: '/state/nc/raleigh',
                    latitude: 35.7795,
                    longitude: -78.6381
                },
                {
                    balloonText: "Sunset Beach, NC",
                    url: '/state/nc/sunset-beach',
                    latitude: 33.908940317844724,
                    longitude: -78.57486332927814
                },
                {
                    balloonText: "Greenville, SC",
                    url: '/state/sc/greenville',
                    latitude: 34.8526,
                    longitude: -82.3940
                },
                {
                    balloonText: "York County, SC",
                    url: '/state/sc/york-county',
                    latitude: 34.2695,
                    longitude: -80.8407
                },
                {
                    balloonText: "Myrtle Beach, SC",
                    url: '/state/sc/myrtle-beach',
                    latitude: 33.6891,
                    longitude: -78.8867,
                },
                {
                    balloonText: "Charleston, SC",
                    url: '/state/sc/charleston',
                    latitude: 32.85921138366729,
                    longitude: -79.9698537001188
                },
                {
                    balloonText: "Nashville, TN",
                    url: '/state/tn/nashville',
                    latitude: 36.1626,
                    longitude: -86.7816
                },
                {
                    balloonText: "Austin, TX",
                    url: '/state/tx/austin',
                    latitude: 30.2671,
                    longitude: -97.7430
                },
                {
                    balloonText: "Dallas/Ft. Worth, TX",
                    url: '/state/tx/dallasft-worth',
                    latitude: 32.7766,
                    longitude: -96.7969
                },
                {
                    balloonText: "Houston, TX",
                    url: '/state/tx/houston',
                    latitude: 29.7604,
                    longitude: -95.3698
                },
                {
                    balloonText: "San Antonio, TX",
                    url: '/state/tx/san-antonio',
                    latitude: 28.5992,
                    longitude: -98.96
                },
                {
                    balloonText: "Salt Lake City, UT",
                    url: '/state/ut/salt-lake-city',
                    latitude: 40.7608,
                    longitude: -111.89
                }
            ];
            // * Complete our location objects with standard values
            var locations = _.forEach(mapLocations, function (item, i) {
                return _.merge(item, {
                    svgPath: targetSVG,
                    color: '#fefefe',
                    rollOverScale: 2,
                    tabIndex: i
                });
            });
            // * Build the Map
            map = new AmCharts.AmMap();
            map.areasSettings = {
                autoZoom: false,
                outlineColor: '#ffffff',
            };
            map.addClassNames = true;
            map.dragMap = false;
            map.zoomControl = {
                homeButtonEnabled: false,
                zoomControlEnabled: false
            };
            map.mouseWheelZoomEnabled = false;
            map.zoomOnDoubleClick = false;
            map.dataProvider = {
                mapVar: AmCharts.maps.usa2Low,
                getAreasFromMap: false,
                areas: [{
                    id: "US-AL",
                    color: "#002F56",
                    rollOverColor: "#00A1FF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-AR",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-AZ",
                    color: "#002F56",
                    rollOverColor: "#00A1FF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-CA",
                    color: "#002F56",
                    rollOverColor: "#00A1FF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-CO",
                    color: "#002F56",
                    rollOverColor: "#00A1FF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-CT",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-DC",
                    color: "#FFFFFF",
                    rollOverColor: "#002F56",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-DE",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-FL",
                    color: "#002F56",
                    rollOverColor: "#00A1FF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-GA",
                    color: "#002F56",
                    rollOverColor: "#00A1FF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-IA",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-ID",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-IL",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-IN",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-KS",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-KY",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-LA",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-MA",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-MD",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-ME",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-MI",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-MN",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-MO",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-MS",
                    color: "#002F56",
                    rollOverColor: "#00A1FF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-MT",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-NC",
                    color: "#002F56",
                    rollOverColor: "#00A1FF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-ND",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-NE",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-NH",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-NJ",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-NM",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-NV",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-NY",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-OH",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-OK",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-OR",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-PA",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-RI",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-SC",
                    color: "#002F56",
                    rollOverColor: "#00A1FF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-SD",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-TN",
                    color: "#002F56",
                    rollOverColor: "#00A1FF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-TX",
                    color: "#002F56",
                    rollOverColor: "#00A1FF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-UT",
                    color: "#002F56",
                    rollOverColor: "#00A1FF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-VA",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-VT",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-WA",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-WI",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-WV",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                },
                {
                    id: "US-WY",
                    color: "#FFFFFF",
                    rollOverColor: "#FFFFFF",
                    outlineColor: "#A7A9AC",
                    rollOverOutlineColor: "#A7A9AC",
                    outlineThickness:2,
                }
                ],
                images: locations
            };
            map.write('mapdiv-usa');
        });

        $(window).resize(function () {
            $('.amcharts-chart-div').css('width', $(window).width() - 30);
        });

        $(window).on('orientationchange', function () {
            $('.amcharts-chart-div').css('width', $(window).width() - 30);
        });
    })();
}
